module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/components/main-root.html
// module id = ./src/app/main/components/main-root.html
// module chunks = main